import React from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
export const TaskTimelineListItem = (props) => {
    const { timelineActivity } = props;
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.taskCompletedBy ?? timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: 'Task', value: timelineActivity.taskName ?? '', backgroundColor: 'F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }),
            React.createElement(TimelineListItemInfoChip, { label: 'Assigned To', value: timelineActivity.taskAssignedTo ?? '', backgroundColor: 'F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }),
            React.createElement(TimelineListItemInfoChip, { label: 'Due Date', value: dayjs(timelineActivity.taskDueDate).format('MM/DD/YYYY') ?? '', backgroundColor: 'F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false })),
        React.createElement("textarea", { style: {
                fontFamily: 'Lato, sans-serif',
                fontWeight: '400',
                fontSize: '16px',
                color: '#00000061',
                padding: '5px',
                width: '70%',
                border: '1px solid #0000003B',
                borderRadius: '4px',
                height: '65px',
                overflowY: 'scroll',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 transparent'
            }, value: timelineActivity.notes ?? '', readOnly: true })));
};
